<opac-user-title
  [title]="'checkouts.title' | translate"
  [skeleton]="isLoading">
</opac-user-title>

<div class="user-area-wrapper" *ngIf="!isLoading">
  <opac-no-results
    *ngIf="!(checkouts$ | async).length"
    [label]="'checkouts.noCheckouts' | translate">
    <opac-no-results-cta>
      {{ 'checkouts.browse' | translate }}
      <opac-button type="secondary" (click)="explore()"> {{ 'search.explore' | translate }} </opac-button>
    </opac-no-results-cta>
  </opac-no-results>

  <app-record-card-grid>
    <app-user-checkout-item
      *ngFor="let checkout of checkouts$ | async"
      [checkout]="checkout"
      [userId]="userService.getUserId()"></app-user-checkout-item>
  </app-record-card-grid>
</div>

<ng-container *ngIf="isLoading">
  <app-record-card-grid>
    <ng-container *ngFor="let i of [1, 2, 3, 4]; let last = last">
      <card-item-skeleton></card-item-skeleton>
      <opac-skeleton *ngIf="!last" class="hide-tablet" style="height: 1px; margin: 0 -16px"></opac-skeleton>
    </ng-container>
    <opac-gradient></opac-gradient>
  </app-record-card-grid>
</ng-container>
